import { render } from "./TabsPage.vue?vue&type=template&id=0633aa20"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__